package com.devi3east.bashbuddy.di

import com.devi3east.bashbuddy.clientFactory.HttpClientFactory
import org.koin.core.context.startKoin
import org.koin.core.module.Module
import org.koin.dsl.KoinAppDeclaration

fun initKoin(
    factory: HttpClientFactory,
    additionalModules: List<Module> = emptyList(),
    appDeclaration: KoinAppDeclaration = {}
) = startKoin {
    appDeclaration()
    modules(
                additionalModules +
                cacheModule() +
                networkModule(factory) +
                dataModule() +
                viewModelModule() +
                platformModule()
    )
}